const BASE_KPI_DASHBOARD = {
  year: '2026',
  period: '2026 Q1',
  updatedAt: '05-20 10:30',
  totalRate: 0,
  sections: [
    {
      id: 'customer',
      titleKey: 'kpi_section_customer_development',
      icon: 'friends-o',
      accent: '#11ad6c',
      softColor: 'rgba(17, 173, 108, 0.14)',
      metrics: [
        {
          titleKey: 'kpi_target_customer_count',
          periodKey: 'kpi_period_current',
          type: 'progress',
          value: '--',
          progress: 0,
          footerKey: 'kpi_completion_rate',
          footerValue: '--'
        },
        {
          titleKey: 'kpi_ab_customer_ratio',
          periodKey: 'kpi_period_current',
          type: 'progress',
          value: '--',
          progress: 0,
          footerKey: 'kpi_target_short',
          footerValue: '--'
        },
        {
          titleKey: 'kpi_abc_customer_coverage',
          periodKey: 'kpi_period_month',
          type: 'coverage',
          coverage: [
            { name: 'A', value: '--', progress: 0 },
            { name: 'B', value: '--', progress: 0 },
            { name: 'C', value: '--', progress: 0 }
          ]
        },
        {
          titleKey: 'kpi_abc_customer_monthly_coverage_frequency',
          periodKey: 'kpi_period_month',
          type: 'coverage',
          coverage: [
            { name: 'A', value: '--', progress: 0 },
            { name: 'B', value: '--', progress: 0 },
            { name: 'C', value: '--', progress: 0 }
          ]
        }
      ]
    },
    {
      id: 'digital',
      titleKey: 'kpi_section_digital_interaction',
      icon: 'send-gift-o',
      accent: '#1e63e9',
      softColor: 'rgba(30, 99, 233, 0.14)',
      metrics: [
        {
          titleKey: 'kpi_target_customer_bind_rate',
          periodKey: 'kpi_period_current',
          type: 'progress',
          value: '--',
          progress: 0,
          footerKey: 'kpi_target_short',
          footerValue: '>=60%'
        },
        {
          titleKey: 'kpi_quarterly_content_push',
          periodKey: 'kpi_period_quarter',
          type: 'progress',
          value: '--',
          target: '150',
          progress: 0,
          footerKey: 'kpi_target_short',
          footerValue: '>=150'
        }
      ]
    },
    {
      id: 'behavior',
      titleKey: 'kpi_section_behavior_process',
      icon: 'todo-list-o',
      accent: '#ff7a55',
      softColor: 'rgba(255, 122, 85, 0.14)',
      metrics: [
        {
          titleKey: 'kpi_daily_face_to_face_calls',
          periodKey: 'kpi_period_month',
          type: 'progress',
          value: '--',
          target: '10',
          unitKey: 'kpi_calls_per_day_unit',
          progress: 0,
          footerKey: 'kpi_target_short',
          footerValue: '>=10'
        },
        {
          titleKey: 'kpi_visit_plan_count',
          periodKey: 'kpi_period_week',
          type: 'progress',
          value: '--',
          target: '15',
          progress: 0,
          footerKey: 'kpi_weekly_target_short',
          footerValue: '>=15'
        }
      ]
    }
  ]
};

export function getKpiDashboard(roleName) {
  const normalizedRole = roleName === '销售' ? 'MR' : roleName;

  if (normalizedRole === 'MR' || normalizedRole === 'GBA' || normalizedRole === 'GA') {
    return JSON.parse(JSON.stringify(BASE_KPI_DASHBOARD));
  }

  return JSON.parse(JSON.stringify(BASE_KPI_DASHBOARD));
}
